<ion-content class="no_padding" scroll-y="false">
    @if(this.isFetching){
        <div class="bloc_loading">
            <ion-spinner></ion-spinner>
        </div>        
    }
    @else{    
        <marv-tabs [tabs]="this.tabsAlerts">
            <marv-tab tabId="unread">
                @for(alertMessage of this.alertMessagesUnread; track $index){
                    <app-alert-item [alert]="alertMessage"/>
                }
            </marv-tab>
            <marv-tab tabId="all">
                @for(alertMessage of this.alertMessagesAll; track $index){
                    <app-alert-item [alert]="alertMessage"/>
                }
            </marv-tab>
        </marv-tabs>
    }
</ion-content>
